import { render, staticRenderFns } from "./wsLink.vue?vue&type=template&id=5a9857f2&scoped=true&"
import script from "./wsLink.vue?vue&type=script&lang=js&"
export * from "./wsLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9857f2",
  null
  
)

export default component.exports